import { createSlice } from '@reduxjs/toolkit';

type proformaAutomotorModal = {
  proformaAutomotorModalActive: boolean;
  openProformaAutomotorModal: boolean;
  reloadOrderList: boolean;
  mappingForm: boolean;
  headerLineMapping: number;
  resendOrder: boolean;
  closeModal: boolean;
};

const initialState: proformaAutomotorModal = {
  proformaAutomotorModalActive: false,
  openProformaAutomotorModal: false,
  reloadOrderList: false,
  mappingForm: false,
  headerLineMapping: 1,
  resendOrder: false,
  closeModal: false
};

const proformaAutomotorModalSlice = createSlice({
  name: 'proformaAutomotorModal',
  initialState,
  reducers: {
    setProformaAutomotorModalActive(state, { payload }) {
      state.proformaAutomotorModalActive = payload;
    },
    setOpenProformaAutomotorModal(state, { payload }) {
      state.openProformaAutomotorModal = payload;
    },
    setReloadOrderList(state, { payload }) {
      state.reloadOrderList = payload;
    },
    setMappingForm(state, { payload }) {
      state.mappingForm = payload;
    },
    setHeaderLineMapping(state, { payload }) {
      state.headerLineMapping = payload;
    },
    setResendOrder(state, { payload }) {
      state.resendOrder = payload;
    },
    setCloseModal(state, { payload }) {
      state.closeModal = payload;
    }
  }
});

export const { setProformaAutomotorModalActive, setOpenProformaAutomotorModal, setReloadOrderList, setMappingForm, setHeaderLineMapping, setResendOrder, setCloseModal } = proformaAutomotorModalSlice.actions;

export default proformaAutomotorModalSlice.reducer;
